import React from 'react';
import { Download, X } from 'lucide-react';
import { COLORS } from '../../../../utils/constants';
import QRCode from 'react-qr-code';

const QRPreviewModal = ({ currency, address, onClose, onDownload }) => {
  if (!address) return null;
  
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0,0,0,0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px',
    }}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: '20px',
        padding: '32px',
        textAlign: 'center',
        maxWidth: '400px',
        width: '100%',
      }}>
        <h3 style={{ color: '#000', fontSize: '20px', fontWeight: '700', marginBottom: '8px' }}>
          {currency}
        </h3>
        <p style={{ color: '#666', fontSize: '12px', marginBottom: '24px', wordBreak: 'break-all', fontFamily: 'monospace' }}>
          {address}
        </p>
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '16px', display: 'inline-block', marginBottom: '24px' }}>
          <QRCode 
            id={`qr-preview-${currency}`}
            value={address}
            size={250}
            level="H"
            fgColor="#000000"
            bgColor="#ffffff"
          />
        </div>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={() => onDownload(address, currency)}
            style={{
              padding: '12px 24px',
              backgroundColor: COLORS.primary,
              color: '#000',
              border: 'none',
              borderRadius: '10px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Download size={18} />
            Скачать PNG
          </button>
          <button
            onClick={onClose}
            style={{
              padding: '12px 24px',
              backgroundColor: '#eee',
              color: '#333',
              border: 'none',
              borderRadius: '10px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRPreviewModal;
